import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';

import { IClientOrderRowFilter } from '../models/filters/clientOrderRowFilter';
import { API_CENTRE } from './config';

export default class ClientOrderRowServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ClientOrderRow';
   protected static override getUrlFilter<F extends IClientOrderRowFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
           if (filter.cTime != null)
               url += '&CTime=' + filter.cTime;
           if (filter.centerId != null)
            url += '&CenterId=' + filter.centerId;
           if (filter.clientOrderId != null)
            url += '&ClientOrderId=' + filter.clientOrderId;
       }
       return url;
   }

}
